/* eslint-disable no-param-reassign */
import * as MutationTypes from '@/store/mutation-types';
import { find, findIndex } from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
import KycsApi from '@/backend/api/Kycs';
import { assignHelper } from '../helpers';

const setAnswerHelper = property => (state, { choice, currentQuestionId }) => {
  if (state.form.attributes) {
    const oldQuestionIndex = findIndex(state.form.attributes[property], { id: currentQuestionId });
    const answerObject = {
      id: currentQuestionId,
      answer: choice,
    };
    let answersArray = state.form.attributes[property];

    if (oldQuestionIndex !== -1) {
      answersArray.splice(oldQuestionIndex, 1, answerObject);
    } else if (answersArray) {
      answersArray.push(answerObject);
    } else {
      answersArray = [answerObject];
    }
  }
};

export default {
  namespaced: true,
  state: {
    form: {
      attributes: {
        knowledgeAnswers: [],
        goalAnswers: [],
      },
    },
    knowledgeQuestions: [],
    goalQuestions: [],
    docusignUrl: null,
  },
  mutations: {
    [MutationTypes.VALIDATE_KYC_INTRODUCTION](state) {
      state.form.attributes.introductionValidatedAt = new Date();
    },
    updateField,
    [MutationTypes.SET_KYC](state, form) {
      state.form = form;
      if (state.form) {
        if (state.form.attributes.childrenAges.length) {
          state.form.attributes.childrenAges = state.form.attributes.childrenAges.map((age) => {
            if (typeof age !== 'object') {
              return { value: age };
            }
            return age;
          });
        } else {
          state.form.attributes.childrenAges = [{ value: null }];
        }
      }
    },
    [MutationTypes.SET_KNOWLEDGE_QUESTIONS]: assignHelper('knowledgeQuestions'),
    [MutationTypes.SET_GOAL_QUESTIONS]: assignHelper('goalQuestions'),
    [MutationTypes.SET_KNOWLEDGE_ANSWER]: setAnswerHelper('knowledgeAnswers'),
    [MutationTypes.SET_GOAL_ANSWER]: setAnswerHelper('goalAnswers'),
    [MutationTypes.SET_DOCUSIGN_URL]: assignHelper('docusignUrl'),
  },
  actions: {
    validateKycIntroduction({ dispatch }) {
      return KycsApi.validateKycIntroduction().then(() => {
        dispatch('fetch');
      });
    },
    update({ state }) {
      return KycsApi.update(state.form.attributes);
    },
    fetch({ commit, state }, { force = true } = {}) {
      if (!state.form.id || force) {
        return KycsApi.fetchOngoing().then((response) => {
          commit(MutationTypes.SET_KYC, response.data.data);
        });
      }
      return Promise.resolve();
    },
    fetchKnowledgeQuestions({ commit }) {
      return KycsApi.fetchKnowledgeQuestions().then((response) => {
        commit(MutationTypes.SET_KNOWLEDGE_QUESTIONS, response.data);
      });
    },
    fetchGoalQuestions({ commit }) {
      return KycsApi.fetchGoalQuestions().then((response) => {
        commit(MutationTypes.SET_GOAL_QUESTIONS, response.data);
      });
    },
    uploadIdentityDocument({ dispatch }, file) {
      if (file[0]) {
        return KycsApi.uploadIdentityDocument(file[0].file).then(() => {
          dispatch('fetch', { force: true });
        });
      }
      return null;
    },
    uploadExtraIdentityDocument({ dispatch }, file) {
      if (file[0]) {
        return KycsApi.uploadExtraIdentityDocument(file[0].file).then(() => {
          dispatch('fetch', { force: true });
        });
      }
      return null;
    },
    uploadProofOfAddress({ dispatch }, file) {
      if (file[0]) {
        return KycsApi.uploadProofOfAddress(file[0].file).then(() => {
          dispatch('fetch', { force: true });
        });
      }
      return null;
    },
    submit({ dispatch }) {
      return KycsApi.submit().then(() => {
        dispatch('fetch', { force: true });
      });
    },
    fetchValidated({ commit }) {
      return KycsApi.fetchValidated().then((response) => {
        commit(MutationTypes.SET_KYC, response.data.data);
      });
    },
    sign() {
      return KycsApi.sign();
    },
  },
  getters: {
    getField,
    getAnswer: state => (id) => {
      if (state.form.attributes.knowledgeAnswers) {
        return find(state.form.attributes.knowledgeAnswers, { id });
      }
      return null;
    },
    getGoalAnswer: state => (id) => {
      if (state.form.attributes.goalAnswers) {
        return find(state.form.attributes.goalAnswers, { id });
      }
      return null;
    },
  },
};
